import { CircularProgress } from "@mui/material";
import { parse } from "cookie";
import { useEffect, useState } from "react";
import { LoaderFunction, MetaFunction, useLoaderData } from "react-router";
import BreadCrubComponent from "~/components/shared-components/BreadCrubComponent";
import IframeWithLoader from "~/components/shared-components/IframeWithLoader";
import { getPageMeta } from "~/lib/helperFuncation/metaHelper";
import { setIsDialogClose, setIsDialogOpen } from "~/lib/store/slice/loginSlice";
import { setFamily, setFamilyMembers, setSmkStatus } from "~/lib/store/slice/myFamilySlice";
import { getBhaktiToken } from "~/lib/store/slice/profileSlice";
import { useAppDispatch } from "~/lib/store/store";
import { AUTH_COOKIE_TOKEN, FALLBACK_IMAGE_URL, ICON_ORANGE_COLOR, LANG } from "~/utils/constant";
import { homeRouteString } from "~/utils/helper-funcations";
import { metaService } from "~/utils/metaService";
import { FamilyData } from "./$lang.my-family";

export const meta: MetaFunction = ({ location, params }) => {
  const lang = params.lang || "en";
  const pathname = location?.pathname || "/";

  const meta = getPageMeta("thal-bhet", lang);

  return metaService({
    title: meta.metaTitle,
    description: meta.metaDescription,
    ogTitle: meta.ogTitle,
    ogDescription: meta.ogDescription,
    ogUrl: pathname,
    ogImg: meta.ogImage || FALLBACK_IMAGE_URL,
    ogWidth: meta.ogImageWidth || "1200",
    ogHeight: meta.ogImageHeight || "630",
    canonicalLink: pathname,
    hreflangs: [
      { hrefLang: "x-default", href: `${pathname}` },
      { hrefLang: "en", href: `${pathname}` },
      { hrefLang: "gu", href: `${pathname}` },
    ],
  });
};

export const loader: LoaderFunction = async ({ params, request }) => {
  const lang = params.lang;
  const paramToken = params.token; // Get token from URL params first

  const cookieHeader = request.headers.get("Cookie") || "";
  const cookies = parse(cookieHeader);
  // Priority: params token first, then cookie token
  const authToken = cookies[AUTH_COOKIE_TOKEN] || null;
  const token = paramToken || null;

  // if (!token || !contentToken) {
  //   return redirect(`/${lang}`);
  // }

  // const apiService = new SmkApiService(token ?? "");
  // const familyData = token ? await apiService.getFamilyMember() : null;

  return Response.json({
    token,
    authToken,
    title: lang === LANG.gujarati ? "થાળ ભેટ" : "Thal Bhet",
    // familyData,
  });
};

export const handle = {
  breadcrumb: (match: any) => {
    const lang = match.params.lang;
    return (
      <BreadCrubComponent
        breadCrub={[
          {
            path: homeRouteString(lang).path,
            title: homeRouteString(lang).home,
          },
        ]}
      />
    );
  },
};

function ThalBhet() {
  const { familyData, authToken, token } = useLoaderData<{ familyData: FamilyData | null; authToken: string; token: string }>();
  const [bhaktiToken, setBhaktiToken] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  // All hooks must be called unconditionally at the top
  useEffect(() => {
    if (!authToken) {
      dispatch(setIsDialogOpen());
    } else {
      (async () => {
        const res = await dispatch(getBhaktiToken()).unwrap();
        if (!res.bhaktiToken) return;
        setBhaktiToken(res.bhaktiToken);
      })();
      dispatch(setIsDialogClose());
    }
  }, [authToken, dispatch]);

  useEffect(() => {
    if (familyData) {
      dispatch(setFamily(familyData?.family_info));
      dispatch(setFamilyMembers(familyData?.family_member));
      dispatch(setSmkStatus(familyData?.my_smk_status));
    }
  }, [familyData, dispatch]);

  // Conditional return happens AFTER all hooks
  if (!authToken) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CircularProgress size={60} style={{ color: ICON_ORANGE_COLOR }} />
      </div>
    );
  }

  return (
    <div className="w-full ">
      <ThalBhetBanner token={token} bhaktiToken={bhaktiToken} />
    </div>
  );
}

const ThalBhetBanner = ({ token, bhaktiToken }: { token: string; bhaktiToken: string | null }) => {
  const iframeUrl = `https://cms.swaminarayanbhagwan.org:36898/?render_token=${bhaktiToken}&deptid=1` + (token ? `&formid=${token}` : "");
  return <IframeWithLoader src={iframeUrl} title="Thal Bhet" loadingText="Loading Thal Bhet Form..." allow="payment" />;
};

export default ThalBhet;
